import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Item } from '@openx/components-targeting/Targeting/shared/SelectedItems/Item.tsx';
import { useTranslation } from 'react-i18next';

export type ReadOnlyMarketSelectionProps = {
  variant: 'region' | 'countries';
  loading: boolean;
  items: string[];
};

export const ReadOnlyMarketSelection = ({ variant, loading, items }: ReadOnlyMarketSelectionProps) => {
  const { t } = useTranslation();

  const label = variant === 'region' ? t('Region') : t('Countries');
  const loadingTestId = `market-${variant}-readonly-loading`;

  return (
    <Grid data-test={`market-${variant}-readonly`} sx={{ mt: 1 }}>
      <Typography variant="body2Bold" data-test={`market-${variant}-label`}>
        {label}
      </Typography>

      <Grid container sx={{ mt: 0.5 }} data-test={`market-${variant}-readonly-list`}>
        {loading ? (
          <Grid>
            <CircularProgress size={14} data-test={loadingTestId} />
          </Grid>
        ) : (
          items.map((item, index) => (
            <Grid key={item}>
              {variant === 'countries' ? (
                <Item testId="market-country-item" readonly item={item}>
                  {item}
                  {index < items.length - 1 ? ',' : ''}
                </Item>
              ) : (
                <Typography variant="body2">{item}</Typography>
              )}
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};
